/**
 *
 * Asynchronously loads the component for DatasetRules Page
 *
 */
import Loadable from 'react-loadable';
export default Loadable({
    loader: function () { return import(/* webpackChunkName: 'DatasetRulesPage' */ './index'); },
    loading: function (props) {
        if (props.error) {
            console.error(props.error);
        }
        return null;
    },
});
